import { useCallback } from 'react'
import { ACTION_TYPE, PRODUCT_PROPERTY } from 'general/constants/AppConstants'
import Utils from 'general/utils/Utils'
import { useAppSelector } from 'hooks/useRedux'
import calculateExchangedMoneyTableData from '../Function/CalculateTableData'

export function useInvoiceCalculations({
  formik,
  actionType,
  setIsChangeTable,
  isChangeTaxRate,
  isChangeTable,
  roundingConfig,
  tableData,
  setTableData,
}) {
  const { values, setFieldValue } = formik
  const { formatNumber } = useAppSelector((state) => state?.systemConfig)
  const calculateAndSetFinalExchangedMoney = useCallback(
    (
      exchangeRate,
      discountMoney,
      total,
      taxMoney,
      totalAfterTax,
      totalTaxReduction,
    ) => {
      if (typeof exchangeRate === 'string') {
        exchangeRate = Utils.parseFormattedNumberToFloat(exchangeRate)
      }
      setFieldValue('exchangedDiscountMoney', discountMoney * exchangeRate)
      setFieldValue('exchangedTotalAfterTax', totalAfterTax * exchangeRate)
      setFieldValue('exchangedTotal', total * exchangeRate)
      setFieldValue('exchangedTaxMoney', taxMoney * exchangeRate)
      setFieldValue(
        'exchangedTotalTaxReduction',
        totalTaxReduction * exchangeRate,
      )
    },
    [setFieldValue],
  )

  const calculateAndSetFinalMoney = useCallback(
    (newTableData) => {
      let { exchangeRate } = values
      let total = 0
      let taxMoney = 0
      let totalAfterTax = 0
      let discountMoney = 0
      let totalTaxReduction = 0

      newTableData.forEach((item) => {
        if (item?.taxMoney) {
          switch (item?.type) {
            case PRODUCT_PROPERTY.GOODS_SERVICE: // type là hàng hoá/ dịch vụ + bình thường
            case PRODUCT_PROPERTY.SPECIAL_GOODS:
              taxMoney += item?.taxMoney
              break
            case PRODUCT_PROPERTY.PROMOTION: // type là hàng khuyến mại không + tổng tiền
              // taxMoney += item?.taxMoney;
              break
            case PRODUCT_PROPERTY.DISCOUNT: // type là chiếu khấu thương mại - bớt đi giá trị
              taxMoney -= item?.taxMoney
              break
            default:
              break
          }
        }
        if (item?.totalUnitPrice) {
          switch (item?.type) {
            case PRODUCT_PROPERTY.GOODS_SERVICE: // type là hàng hoá/ dịch vụ + bình thường
            case PRODUCT_PROPERTY.SPECIAL_GOODS:
              total += item?.totalUnitPrice
              break
            case PRODUCT_PROPERTY.PROMOTION: // type là hàng khuyến mại không + tổng tiền
              break
            case PRODUCT_PROPERTY.DISCOUNT: // type là chiếu khấu thương mại - bớt đi giá trị
              total = total - item?.totalUnitPrice
              break
            default:
              break
          }
        }
        if (item?.taxReduction) {
          switch (item?.type) {
            case PRODUCT_PROPERTY.GOODS_SERVICE: // type là hàng hoá/ dịch vụ + bình thường
            case PRODUCT_PROPERTY.SPECIAL_GOODS:
              totalTaxReduction += item?.taxReduction
              break
            case PRODUCT_PROPERTY.PROMOTION: // type là hàng khuyến mại không + tổng tiền
              break
            case PRODUCT_PROPERTY.DISCOUNT: // type là chiếu khấu thương mại - bớt đi giá trị
              totalTaxReduction = totalTaxReduction - item?.taxReduction
              break
            default:
              break
          }
        }
        if (item?.discountMoney) {
          switch (item?.type) {
            case PRODUCT_PROPERTY.GOODS_SERVICE: // type là hàng hoá/ dịch vụ + bình thường
            case PRODUCT_PROPERTY.SPECIAL_GOODS:
              discountMoney += item?.discountMoney
              break
            case PRODUCT_PROPERTY.PROMOTION: // type là hàng khuyến mại không + tổng tiền
              // taxMoney += item?.taxMoney;
              break
            case PRODUCT_PROPERTY.DISCOUNT: // type là chiếu khấu thương mại - bớt đi giá trị
              // discountMoney -= item?.discountMoney
              break
            default:
              break
          }
        }
      })
      if (
        values.taxRate === 'KHAC' ||
        (actionType === ACTION_TYPE.UPDATE &&
          !isChangeTaxRate &&
          !isChangeTable)
      ) {
        taxMoney = Utils.parseFormattedNumberToFloat(values.taxMoney)
      }

      discountMoney = Utils.roundNumber(
        discountMoney,
        formatNumber?.currencyExchange,
      )
      total = Utils.roundNumber(total, roundingConfig('totalCost'))
      taxMoney = Utils.roundNumber(taxMoney, roundingConfig('totalCost'))
      totalAfterTax = Utils.roundNumber(
        total - discountMoney + taxMoney - totalTaxReduction,
        roundingConfig('totalCost'),
      )
      calculateAndSetFinalExchangedMoney(
        exchangeRate,
        discountMoney,
        total,
        taxMoney,
        totalAfterTax,
        totalTaxReduction,
      )
      setFieldValue('discountMoney', discountMoney)
      setFieldValue('total', total)
      // setFieldValue('exchangedTotal', total * exchangeRate)
      setFieldValue('taxMoney', taxMoney)
      setFieldValue('totalAfterTax', totalAfterTax)
      // setFieldValue('exchangedTotalAfterTax', totalAfterTax * exchangeRate)
      setFieldValue('taxReduction', totalTaxReduction)
      // setFieldValue(
      //   'exchangedTotalTaxReduction',
      //   totalTaxReduction * exchangeRate,
      // )
      setIsChangeTable(false)
    },
    [
      values,
      setFieldValue,
      actionType,
      calculateAndSetFinalExchangedMoney,
      setIsChangeTable,
      roundingConfig,
      formatNumber,
      isChangeTaxRate,
      isChangeTable,
    ],
  )

  const calculateAndSetExchangedMoneyPerItem = useCallback(() => {
    let tempTableData = [...tableData]
    let exchangeRate = Utils.parseFormattedNumberToFloat(values.exchangeRate)

    // Tính toán tiền quy đổi
    let newTableData = calculateExchangedMoneyTableData(
      tempTableData,
      exchangeRate,
    )

    setTableData(newTableData)
  }, [tableData, values.exchangeRate, setTableData])

  return { calculateAndSetFinalMoney, calculateAndSetExchangedMoneyPerItem }
}
